module.exports = __webpack_public_path__ + "img/avatar1.48a243a5.png";